import "./header";
import "./cart";
import { carouselInit } from "./carousel";
import CreateCustomSelect from "./custom-select";
import {
	ShowElement,
	HideElement,
	ToggleElement,
	RemoveAutoFill,
	cleanHotelCardStyles,
} from "./utils";
import { deffer_images } from "./img-defer";

window.addEventListener("load", () => {
	const navbarToggle = document.querySelector(".burger-toggle");
	const sideNavBar = document.querySelector(".side-nav");
	const crossBurger = document.querySelector(".crossed-burger");
	const notificationSection = document.querySelector(".notif-bell");
	const notificationModal = notificationSection?.querySelector(
		".notification-modal"
	);
	// smoothscroll.polyfill();
	document.querySelector("html").style = "margin-top: 0px !important";
	deffer_images({});

	// const splide_sliders = document.querySelectorAll(".splide");

	// if (splide_sliders.length) {
	// 	Splide.defaults = {
	// 		type: "loop",
	// 		perPage: 3,
	// 		gap: 20,
	// 		perMove: 1,
	// 	};

	// 	for (const slider of splide_sliders) {
	// 		slider.splide = new Splide(
	// 			slider,
	// 			slider.dataset.options ? JSON.parse(slider.dataset.options) : {}
	// 		);
	// 		const images = slider.querySelectorAll("img");

	// 		console.log(slider.dataset.options);

	// 		for (const image of images) {
	// 			if (!image.dataset.srcset) continue;

	// 			image.srcset = image.dataset.srcset;
	// 		}
	// 		slider.splide.mount();
	// 	}
	// }

	document.addEventListener("click", (e) => {
		if (!e.target.closest("[data-open]")) return;
		ShowElement(e.target.closest("[data-open]"));
	});

	document.addEventListener("click", (e) => {
		const openned_modal = document.querySelector(".modal.show");
		if (e.target.closest("[data-close]")) {
			HideElement(e.target.closest("[data-close]"));
		} else if (e.target == openned_modal) {
			HideElement(openned_modal);
		}
	});

	// Init bootstrap carousel if any carousel is present
	carouselInit();

	document.addEventListener("click", (e) => {
		if (!e.target.closest("[data-togle]")) return;
		ToggleElement(e.target.closest("[data-togle]"));
	});

	cleanHotelCardStyles();

	function noScroll(event) {
		if (event.type === "focus") {
			document.body.classList.add("no-scroll");
		} else if (event.type === "blur") {
			document.body.classList.remove("no-scroll");
		}
	}

	var inputs = Array.from(document.querySelectorAll("input"));

	inputs.forEach(function (input) {
		input.addEventListener("focus", noScroll, false);
		input.addEventListener("blur", noScroll, false);
	});

	if (notificationSection && notificationModal) {
		notificationSection.addEventListener("click", (e) => {
			e.stopPropagation();
			notificationModal.classList.toggle("show");
		});

		document.addEventListener("click", (e) => {
			if (
				notificationModal.classList.contains("show") &&
				!notificationSection.contains(e.target) &&
				!notificationModal.contains(e.target)
			) {
				notificationModal.classList.remove("show");
			}
		});
	}

	//clicking na toggle button
	if (navbarToggle) {
		navbarToggle.addEventListener("click", () => {
			sideNavBar.classList.add("open");
		});
	}

	//closing the side navbar when the cross burger is clicked
	if (crossBurger) {
		crossBurger.addEventListener("click", () => {
			if (sideNavBar.classList.contains("open")) {
				sideNavBar.classList.remove("open");
			} else {
				sideNavBar.classList.add("open");
			}
		});
	}
});
